import { i18n } from 'config/i18n';

export type KycErrorContext = 'PAN' | 'CHEQUE';

const DEFAULT_FALLBACK_MESSAGE = i18n.t('default_fallback_message', 'Something went wrong on our end. Please try again in sometime');
const DEFAULT_ON_VENDOR_UNAVAILABLE = i18n.t('default_on_vendor_unavailable', 'Our verification service is temporarily unavailable. Please try again later.');
const DEFAULT_INVALID_FILE_TYPE_MESSAGE = i18n.t('invalid_file_type', 'Invalid file type. Please upload only JPG or PNG.');

export const resolveKycErrorMessage = (
  errorCode?: string,
  context: KycErrorContext = 'PAN'
) => {
  const normalizedCode = String(errorCode || '').trim().toUpperCase();
  const invalidFileTypeMessage = i18n.t('invalid_file_type', DEFAULT_INVALID_FILE_TYPE_MESSAGE);
  const kyc105Message = i18n.t('kyc_105_error_message', 'You have been temporarily blocked to complete KYC due to multiple failed attempts. Please try again after 24hrs.');

  // Nuipay Downtime Errors
  if (normalizedCode === 'KYC-101' || normalizedCode === 'KYC-102' || normalizedCode === 'KYC-201' ) {
    return DEFAULT_ON_VENDOR_UNAVAILABLE;
  }

  // Razorpay Downtime Errors
  if (normalizedCode === 'KYC-108' || normalizedCode === 'KYC-109') {
    return DEFAULT_ON_VENDOR_UNAVAILABLE;
  }

  // Internal server Errors
  if (normalizedCode === 'KYC-108' || normalizedCode === 'KYC-109') {
    return DEFAULT_FALLBACK_MESSAGE;
  }

  if (normalizedCode === 'KYC-105') {
    return kyc105Message || DEFAULT_FALLBACK_MESSAGE;
  }

  if (normalizedCode === 'KYC-202' || normalizedCode === 'KYC-203') {
    return 'Please upload a clearer photo having all details.';
  }

  if (normalizedCode === 'KYC-204') {
    if (context === 'CHEQUE') {
      return "Unable to verify Bank details. Try later";
    }
    return "Unable to verify PAN details. Try later";
  }

  if (normalizedCode === 'KYC-205') {
    return 'Verification failed. Try again';
  }

  if (normalizedCode === 'KYC-304' || normalizedCode === 'KYC-305') {  
    return "We couldn't find a bank account matching these details. Please check and try again.";
  }

  if (normalizedCode === 'KYC-303') {
    return 'Invalid PAN number. Please check and try again.';
  }

  if (normalizedCode === 'KYC-312') {
    return 'Invalid GST Certificate. Please upload a valid one.';
  }


  if (normalizedCode === 'KYC-402' || normalizedCode === 'KYC-404') {
    return invalidFileTypeMessage || DEFAULT_INVALID_FILE_TYPE_MESSAGE;
  }

  if (normalizedCode === 'KYC-501' || normalizedCode === 'KYC-502') {
    return "We could not verify your document. Please upload a clearer photo having all details.";
  }

  if (normalizedCode === 'KYC-503') {
    return 'The uploaded document does not appear to be a valid PAN card issued by the Indian Income Tax Department. Please upload an original government-issued PAN card image.';
  }

  if (normalizedCode === 'KYC-504') {
    return 'Invalid GST Certificate. Please upload a valid one.';
  }

  if (normalizedCode === 'KYC-505') {
    return 'The uploaded document does not appear to be a valid GST registration certificate. Please upload an original GST certificate.';
  }
  
  if (normalizedCode === 'KYC-704') {
    return "GST details have not been verified";
  }

  if (normalizedCode === 'KYC-705') {
    return "PAN cannot be changed after KYC is verified. Please contact your field officer.";
  }

  if (normalizedCode === 'KYC-706') {
    return "GST legal name does not match PAN card holder name";
  }

    if (normalizedCode === 'KYC-707') {
    return "GST business name does not match bank account holder name";
  }

  if (normalizedCode === 'ERR_NETWORK' || normalizedCode === 'ERR_INTERNET_DISCONNECTED') {
    return 'Upload failed. Check your connection and try again.';
  }

  return DEFAULT_FALLBACK_MESSAGE;
};
